/* Lunai category picker — the controller for the six product-group
   sheets (snippets/lunai-category-picker.liquid).

   A top-level category is a CHOICE GROUP: the card stays a real <a href>
   to the parent collection, and this intercepts only a plain primary
   click to open the picker instead. Owner decision 2026-09-09, after
   device testing: the direct link shipped in 9dcb2d0 skipped the choice.

   Lifted from the inline controller that shipped on /collections, which
   is why the behaviour below is already device-proven:

   - DELEGATED, installed once. The old-old version bound listeners over
     a static NodeList, which left the sheets dead after any Theme Editor
     section re-render. It now also means ONE controller serves both the
     homepage grid and the catalogue page.
   - The tile stays a real <a href> to the group listing. We intercept
     only a plain primary click; Cmd/Ctrl/Shift/Alt and middle clicks
     keep the browser's own behaviour, and with no JS the link works.
   - A trigger whose sheet is not on the page is left alone entirely, so
     a card pointing at a collection the picker does not cover simply
     navigates. That is the fallback that lets the homepage mark its
     cards without knowing which groups Shopify Navigation carries.
   - A sheet is aria-modal, so Tab is trapped inside it (Dawn's
     trapFocus). Without that the tile's only remaining affordance
     would open a dialog a keyboard user could walk straight out of.
   - Escape closes only while a sheet is open, per the rule in
     lunai-theme.js: a page-wide Escape must not teleport focus.
   - Opening a second sheet closes the first, so the focus-return
     target is never overwritten.
   - The grab handle promises a swipe, so a downward drag dismisses —
     same gesture the search sheet uses (assets/lunai-search.js). */
(function () {
  if (window.__lunaiCategoryPicker) return;
  window.__lunaiCategoryPicker = true;

  var root = document.documentElement;
  var opener = null;
  var openSheet = null;

  function panelOf(sheet) { return sheet && sheet.querySelector('.lk-sheet__panel'); }

  function close(sheet) {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    var panel = panelOf(sheet);
    if (panel) {
      unbindSwipe(panel);
      panel.style.transform = '';
      panel.classList.remove('is-settling', 'is-dragging');
    }
    tracking = false;
    root.classList.remove('lk-lock');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(opener);
    else if (opener) opener.focus();
    if (opener) opener.setAttribute('aria-expanded', 'false');
    opener = null;
    openSheet = null;
  }

  function open(trigger) {
    var sheet = document.querySelector('[data-lk-sheet="' + trigger.getAttribute('data-lk-open') + '"]');
    if (!sheet) return false;
    close(openSheet);
    opener = trigger;
    openSheet = sheet;
    sheet.hidden = false;
    root.classList.add('lk-lock');
    trigger.setAttribute('aria-expanded', 'true');
    var panel = panelOf(sheet);
    bindSwipe(panel);
    if (typeof trapFocus === 'function') trapFocus(panel || sheet, panel || sheet);
    else if (panel) panel.focus();
    return true;
  }

  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-lk-close]');
    if (closer) { close(closer.closest('.lk-sheet')); return; }

    var trigger = e.target.closest('[data-lk-open]');
    if (!trigger) return;
    /* leave modified and non-primary clicks to the browser so the
       tile's href still means what it says */
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (open(trigger)) e.preventDefault();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openSheet) { e.stopPropagation(); close(openSheet); }
  });

  /* Swipe down to dismiss. Only from the top of the panel's own scroll,
     and only once the gesture is clearly vertical-downward, so the
     subcategory list still scrolls normally.

     Bound to the PANEL while a sheet is open, not to document: a
     non-passive touchmove on document costs the browser its scrolling
     fast path on every visit to this page, and the catalog is a page
     people scroll. No sheet open, no listeners. */
  var startY = 0, delta = 0, tracking = false, decided = false, dismissing = false;

  function onStart(e) {
    var panel = panelOf(openSheet);
    if (!panel || e.touches.length !== 1) return;
    startY = e.touches[0].clientY;
    delta = 0;
    tracking = true;
    decided = false;
    dismissing = false;
    panel.classList.remove('is-settling');
  }

  function onMove(e) {
    if (!tracking) return;
    var panel = panelOf(openSheet);
    if (!panel) { tracking = false; return; }
    var d = e.touches[0].clientY - startY;
    if (!decided) {
      if (Math.abs(d) < 6) return;                 /* wait for real intent */
      decided = true;
      dismissing = d > 0 && panel.scrollTop <= 0;
      if (!dismissing) { tracking = false; return; }
      panel.classList.add('is-dragging');
    }
    if (d < 0) d = 0;
    delta = d;
    e.preventDefault();                            /* needs passive: false */
    panel.style.transform = 'translateY(' + d + 'px)';
  }

  function onEnd() {
    var panel = panelOf(openSheet);
    if (!tracking || !dismissing || !panel) { tracking = false; return; }
    tracking = false;
    panel.classList.add('is-settling');
    /* a quarter of the panel, floored so a short sheet still needs a
       deliberate drag */
    if (delta > Math.max(90, panel.offsetHeight * 0.25)) {
      panel.style.transform = 'translateY(100%)';
      var target = openSheet;
      setTimeout(function () { close(target); }, 190);
    } else {
      panel.style.transform = '';
      setTimeout(function () {
        panel.classList.remove('is-settling', 'is-dragging');
      }, 220);
    }
  }

  function bindSwipe(panel) {
    if (!panel || panel._lkSwipe) return;
    panel._lkSwipe = true;
    panel.addEventListener('touchstart', onStart, { passive: true });
    panel.addEventListener('touchmove', onMove, { passive: false });
    panel.addEventListener('touchend', onEnd, { passive: true });
    panel.addEventListener('touchcancel', onEnd, { passive: true });
  }
  function unbindSwipe(panel) {
    if (!panel || !panel._lkSwipe) return;
    panel._lkSwipe = false;
    panel.removeEventListener('touchstart', onStart);
    panel.removeEventListener('touchmove', onMove);
    panel.removeEventListener('touchend', onEnd);
    panel.removeEventListener('touchcancel', onEnd);
  }
})();
